module.exports = __webpack_public_path__ + "79fe7c004760d0c2dc4f389d254b93d4.svg";